import toastr from 'toastr';
import '../../node_modules/toastr/build/toastr.css';

toastr.options = {
  preventDuplicates: true,
  timeOut: 4000,
  extendedTimeOut: 4000,
  closeButton: true,
  positionClass: 'toast-bottom-right'
};

export default toastr;
